export default __webpack_public_path__ + "static/media/DSCF1688.2183c274.jpg";